import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import propTypes from 'prop-types';
import {
    CardBody,
    Container,
    Row,
    Col
} from 'reactstrap';

import SneakerTitle from './SneakerTitle';
import SneakerRelease from './SneakerRelease';
import SneakerFooter from './SneakerFooter';

export default class SneakerSummary extends Component{
    render(){
      return(
        <CardBody className="summary">
          <SneakerTitle title={this.props.sneaker.display_name}/>
          <SneakerRelease 
            release_date={this.props.sneaker.release_date} 
            outOfStockLabel={this.props.outOfStockLabel}
          />
        </CardBody>
      )
    }
}

SneakerSummary.propTypes = {
  outOfStockLabel:propTypes.bool,
}
SneakerSummary.defaultProps={
  outOfStockLabel: true,
}